import { useState, useEffect } from 'react';
import { getCandidateStatsByJobIdsPostgres } from 'wisestep-api';

import {
  jobCrmStatesCount,
  candidateStatsDefaultQuery,
} from '../../../jobs/listing/JObSearchFilterDefaultQuery';

export const useCandidateStats = (jobId: string): jobCrmStatesCount => {
  const [jobStats, setJobStats] = useState<jobCrmStatesCount>({
    mappingsByJob: 0,
    applicationsByJob: 0,
    uploadedByJob: 0,
    submissionsByJob: 0,
  });

  useEffect(() => {
    const candidateStats = async () => {
      const q = { ...candidateStatsDefaultQuery };
      const jobIds: string[] = [jobId];
      q.jobIds = jobIds.toString();
      const stats = await getCandidateStatsByJobIdsPostgres(q);
      setJobStats(stats.data);
    };
    candidateStats();
  }, [jobId]);

  return jobStats;
};
